function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "40"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_295",
  "data-name": "Group 295",
  transform: "translate(-1635 -124)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_289",
  "data-name": "Group 289",
  transform: "translate(1635 124)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M12 22a10 10 0 1110-10 10 10 0 01-10 10zm0-2a8 8 0 10-8-8 8 8 0 008 8zM11 7h2v2h-2zm0 4h2v6h-2z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("text", {
  id: "Info",
  transform: "translate(1636 161)",
  fill: "#fff",
  fontSize: "12",
  fontFamily: "SegoeUI, Segoe UI",
  letterSpacing: ".018em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: "0",
  y: "0"
}, "Info")))));